import utils from './utils';

export default {
    setLanguage: data => utils.post(`${BASE_API_URL}/set_language/`, data),
};



// WEBPACK FOOTER //
// ./src/api/users.js